import * as _ from 'lodash';
import { ContentScores } from './contentScores';
import { interpolate } from './utils/interpolate';
export function interpolateSingleValue(val, realValues, placeholderValues, defaultValues) {
    if (!_.isString(val)) {
        return { content: val, score: 1, isFinal: true };
    }
    var interpolationFn = interpolate(val);
    if (!interpolationFn) {
        // in case it's not really a template.
        return { content: val, score: 1, isFinal: true };
    }
    var contentWithNoValues = interpolationFn({}); // in case it's a template with constant values
    if (contentWithNoValues) {
        return {
            content: contentWithNoValues,
            score: ContentScores.scoreForUsingDefaultValues,
            isFinal: true,
        };
    }
    var contentWithRealValues = interpolationFn(realValues);
    if (contentWithRealValues) {
        // in case it is a template, and all the values are found
        return {
            content: contentWithRealValues,
            score: ContentScores.scoreForUsingTemplateValues,
            isFinal: true,
        };
    }
    var contentWithPlaceholderValues = interpolationFn(placeholderValues);
    if (contentWithPlaceholderValues) {
        return {
            content: contentWithPlaceholderValues,
            score: ContentScores.scoreForUsingPlaceholderValues,
            isFinal: true,
        };
    }
    var withDefaults = interpolationFn(defaultValues);
    var isFinal = withDefaults !== undefined;
    var score = isFinal ? ContentScores.scoreForUsingDefaultValues : 1;
    return { content: withDefaults || val, score: score, isFinal: isFinal }; // default values
}
//# sourceMappingURL=contentInterpolator.js.map